import React, { useState, useEffect } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import axios from "axios";
import { handleApiError } from "@utils/errorHandler";
import { WarningPopUp, Image } from "hesus-ui-kit";
import editIcon from "@icons/blue-edit.svg";
import deleteIcon from "@icons/red-delete.svg";

import {
  RowHeader,
  GridRow,
  GridItem,
  GridSubItem,
} from "../../DisputeView.styled";

const Header = (props) => {
  const {
    t,
    data,
    indexCount,
    seRefreshDisputeData,
    updateDisputeRefeshStatus,
    onDisputeEdit,
  } = props;

  const [isConfirmVisible, setConfirmVisibility] = useState(false);
  const [isConfirm, setActionConfirmStatus] = useState(false);
  const [disputeId, setDisputeId] = useState("");

  const onDisputeDelete = (id) => {
    setDisputeId(id);
    setConfirmVisibility(true);
  };

  const onPopUpCancel = () => {
    setDisputeId("");
    setConfirmVisibility(false);
    setActionConfirmStatus(false);
  };

  const onPopUpConfirm = () => {
    setConfirmVisibility(false);
    setActionConfirmStatus(true);
  };

  useEffect(() => {
    if (isConfirm) {
      axios
        .delete(`/disputes/${disputeId}`)
        .then(() => {
          setDisputeId("");
          seRefreshDisputeData(true);
          updateDisputeRefeshStatus();
        })
        .catch((error) => {
          seRefreshDisputeData(false);
          handleApiError(error);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isConfirm]);

  return (
    <>
      <RowHeader borderRadius={indexCount === 0 ? "5px 5px 0px 0px" : "0px"}>
        <GridRow
          column="auto 1fr auto"
          marginTop="0px"
          marginBottom="0px"
          gridGap="0rem"
          padding="5px 10px"
        >
          <GridItem
            fontSize="16px"
            fontWeight="700"
            color="#fff"
            textAlign="left"
            leftRadius="5px"
          >
            {t("DISPUTE") + " #" + data?.id}
          </GridItem>
          <GridSubItem
            fontStyle="italic"
            fontSize="16px"
            color="#fff"
            alignContent="center"
          >
            {" - "}
            {t("DISPUTE_REPORTED_BY")} {data?.createdBy?.firstname}{" "}
            {data?.createdBy?.lastname}
          </GridSubItem>

          <GridSubItem alignContent="center">
            <Image
              src={editIcon}
              onClick={() => onDisputeEdit(data?.id)}
              alt={t("DISPUTE_ACTION_TOOLTIP_EDIT")}
              title={t("DISPUTE_ACTION_TOOLTIP_EDIT")}
              className="dispute-view__action-icon"
            />
            <Image
              src={deleteIcon}
              styles={{ marginLeft: "5px" }}
              className="dispute-view__action-icon"
              onClick={() => onDisputeDelete(data?.id)}
              alt={t("DISPUTE_ACTION_TOOLTIP_DELETE")}
              title={t("DISPUTE_ACTION_TOOLTIP_DELETE")}
            />
          </GridSubItem>
        </GridRow>
      </RowHeader>

      {isConfirmVisible && (
        <WarningPopUp
          title={t("DISPUTE_CONFIRMATION_BOX_DELETE")}
          message={t("DISPUTE_CONFIRMATION_BOX_DELETE_CONTENT")}
          onPopUpCancel={onPopUpCancel}
          onPopUpConfirm={onPopUpConfirm}
          ValidateContent={t("YES")}
          CancelContent={t("CANCEL")}
        />
      )}
    </>
  );
};

Header.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation()(Header);
